import useCurrentUser from './useCurrentUser';
import mrf from 'mrf.config';

export default function useLocale() {
    const currentUser = useCurrentUser();
    const locale = window.navigator.userLanguage || window.navigator.language;

    return mrf?.locale ?? currentUser?.language ?? locale;
}
